import TransferPharmacyPage from "./TransferPharmacyPage";

export default TransferPharmacyPage;

export * from "./TransferPharmacyPage";
